module.exports = __webpack_public_path__ + "static/media/logo.2d6c4e87.png";